import baseAPI from '@/api/base';
import { EditProjectEmployee, GetProjectEmployee, RegisterProjectEmployee } from '@/dtos/project_employee.dto';
import {
  DELETE_PROJECT_EMPLOYEE_URL,
  EDIT_PROJECT_EMPLOYEE_URL,
  GET_PROJECT_EMPLOYEE_URL,
  REGISTER_PROJECT_EMPLOYEE_URL,
  TOGGLE_PROJECT_EMPLOYEE_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class ProjectEmployee {
  static getProjectEmployees = async (getProjectEmployee: GetProjectEmployee): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_PROJECT_EMPLOYEE_URL, {
      params: getProjectEmployee,
    });
    console.log('response', response);
    return response;
  };

  static registerProjectEmployee = async (
    registerProjectEmployee: RegisterProjectEmployee
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_PROJECT_EMPLOYEE_URL, {
      ...registerProjectEmployee,
    });
    console.log('response', response);
    return response;
  };

  static editProjectEmployee = async (editProjectEmployee: EditProjectEmployee): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_PROJECT_EMPLOYEE_URL, {
      ...editProjectEmployee,
    });
    return response;
  };

  static toggleProjectEmployeeIsActive = async (
    editProjectEmployee: EditProjectEmployee
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_PROJECT_EMPLOYEE_IS_ACTIVE_URL,
      {
        ...editProjectEmployee,
      }
    );
    return response;
  };

  static deleteProjectEmployee = async (projectEmployeeId: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_PROJECT_EMPLOYEE_URL}/${projectEmployeeId}`
    );
    return response;
  };
}

export default ProjectEmployee;

